import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Constants
import locales from "./locales";
var ibanFormatterSpecs = _defineProperty(_defineProperty(_defineProperty({}, locales.CH, [{
  "char": /([A-Z, 0-9])/,
  repeat: 5
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 1
}]), locales.LI, [{
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 4
}, {
  exactly: ' '
}, {
  "char": /([A-Z, 0-9])/,
  repeat: 5
}]), "DEFAULT_SPEC", /(.{1,4})/g);
export default {
  ibanFormatterSpecs: ibanFormatterSpecs
};